import * as React from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import * as moment from 'moment';
import { fetchApi } from '../../services/api';
const DocumentTitle = require('react-document-title');

type Props = RouteComponentProps<{ }>;

type State = {
    upcomingBirthdays: ReportData[];
}

type ReportData = {
    ChildID: number;
    ChildName: string;
    FacilityName: string;
    Age: number;
    Birthday: Date;
}

export default class UpcomingBirthdays extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);

        this.state = {
            upcomingBirthdays: [],
        }
    }

    public componentWillMount() {
        this.getReport();
    }

    public render() {
        return <React.Fragment>
            <DocumentTitle title="Upcoming Birthdays" />
            <h1>Upcoming Birthdays (7 Days)</h1>
            { this.renderReportTable() }
        </React.Fragment>;
    }

    private renderReportTable() {
        return <table className='table'>
            <thead>
                <tr>
                    <th>Child Name</th>
                    <th>Facility</th>
                    <th>Turning</th>
                    <th>Birthday</th>
                </tr>
            </thead>
            <tbody>
                {this.state.upcomingBirthdays.map((upcomingBirthday, index) =>
                    <tr key={ index }>
                        <td>
                            <Link to={ `/child/${ upcomingBirthday.ChildID }` }>
                                {upcomingBirthday.ChildName}
                            </Link>
                        </td>
                        <td>{upcomingBirthday.FacilityName}</td>
                        <td>{upcomingBirthday.Age}</td>
                        <td>{moment(upcomingBirthday.Birthday).format("YYYY-MM-DD")}</td>
                    </tr>
                )}
            </tbody>
        </table>;
    }

    private getReport() {
        const data = {
            FacilityID: localStorage.getItem("FACILITY_ID")
        }
        fetchApi('/api/Reports/UpcomingBirthdays', data, 'POST')
            .then((upcomingBirthdays: ReportData[]) => {
                this.setState({ upcomingBirthdays })
            })
    }
}
